import { UniqueIdentifier } from '@dnd-kit/core';
import React from 'react';

import { HStack, Paragraph, Text, VStack } from '@eluve/components';
import { BlockType } from '@eluve/llm-outputs';

import { BlockTypeIcon } from './BlockTypeIcon';
import { templateBuilderStore } from './templateBuilderStore';

const blocks: {
  name: string;
  tip: string;
  type: BlockType;
}[] = [
  {
    type: 'group',
    name: 'Group',
    tip: 'Container for other blocks',
  },
  {
    type: 'text',
    name: 'Text block',
    tip: 'Freeform text',
  },
  {
    type: 'checkbox',
    name: 'Checkboxes',
    tip: 'List of checkbox options',
  },
];

export const BlockPicker: React.FC<{
  parentId: UniqueIdentifier | null;
  index?: number;
  showTips?: boolean;
}> = ({ parentId, index, showTips }) => {
  const onBlockClick = (blockType: BlockType) => {
    templateBuilderStore.send({
      parentId,
      type: 'addBlock',
      blockType,
      placeAtIndex: index,
    });
  };

  return (
    <HStack gap={3} className="items-stretch">
      {blocks.map(({ name, tip, type }, i) => {
        return (
          <React.Fragment key={i}>
            <VStack
              align="start"
              className="rounded-lg border p-4 hover:cursor-pointer hover:bg-bg-secondary"
              gap={1}
              onClick={() => onBlockClick(type)}
            >
              <HStack gap={3} justify={showTips ? 'start' : 'center'}>
                <BlockTypeIcon type={type} />
                <Text size="md">{name}</Text>
              </HStack>
              {showTips && (
                <Paragraph color="tertiary" size="sm">
                  {tip}
                </Paragraph>
              )}
            </VStack>
          </React.Fragment>
        );
      })}
    </HStack>
  );
};
